import React, { useContext, useState, useEffect } from "react";
import logo from '../assets/logo/Homepro.png';
import iconUser from '../assets/icons/navbar/icon-user.png';
import iconLogout from '../assets/icons/navbar/icon-logout.png';
import ModalComponent from "../components/Modal/ModalComponent";
import UserDetail from "./sidebar/userDetail";
import AuthenticationService from "../services/AuthenticationService";
import * as getUserInfo from "../actions/GetUserInfo.action"
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { PersonCircle, BoxArrowRight } from "react-bootstrap-icons";
import { useTranslation } from 'react-i18next';
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { Dropdown } from "../components/Components";

export default function Navbar({ userData, setUserData }) {
  const dispatch = useDispatch()
  const authentication = AuthenticationService();
  const [OpenUserDetail, setopenUserDetail] = useState(false);
  const GetUserInfoReducer = useSelector(({ GetUserInfoReducer }) => GetUserInfoReducer)
  const params = new URLSearchParams(window.location.search);
  const [selectedLanguage, setSelectedLanguage] = useState('th');
  const options = userData?.subList?.filter(item => item.subNo).map(subItem => ({
    label: `${subItem.subNo + " - " + subItem?.subName}`,
    value: subItem.subNo
  }));
  const [selectedValue, setselectedValue] = useState(null);

  const navigate = useNavigate();

  const getdataMenu = async () => {
    const lang = userData?.lang?.split("-")[0];
  };

  const { t, i18n } = useTranslation();

  const handleClickLogout = () => {
    // MessageAlert.confirm
    // sessionStorage.removeItem('menuData');
    localStorage.removeItem('userData');
    localStorage.removeItem('chiefNo');
    localStorage.removeItem('subNoData');
    setUserData(null);
    // setChiefNo(null);
    navigate('/');
  }

  useEffect(() => {
    const subNoData = userData?.subList;

    if (subNoData) {
      setselectedValue(options[0]);
      localStorage.setItem("subNoData", JSON.stringify(options[0]));
    }
  }, [userData]);

  useEffect(() => {
    getdataMenu();
    i18n.changeLanguage("th");
  }, []);

  const handlechangelanguage = (e, value) => {
    if (value) {
      setSelectedLanguage(value);
      i18n.changeLanguage(value);
    }
  }

  const openUserDetail = () => {
    setopenUserDetail(true);
  };

  const closeUserDetail = () => {
    setopenUserDetail(false);
  };

  const handlechangevalue = (value) => {
    localStorage.setItem("subNoData", JSON.stringify(value));
    window.dispatchEvent(new Event('storage'));
    window.postMessage({ subNo: value }, '*');
    setselectedValue(value);
  }

  return (
    <div className="nav-1">
      <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
        <div className="nav-div-l1">
          <img src={logo} className="nav-logo-1" alt="logo" style={{ paddingTop: '10px', display: 'flex' }} />
        </div>
        <div className="nav-div-c" style={{ margintop: "10px" }}>
          <div style={{ display: 'inline-block', paddingLeft: "10px" }}>
            <p className="nav-header-title1">{t('ContractorManagement')}</p>
            <p className="nav-header-sub-title1">
              <span>{t('Language')} :
                <ToggleButtonGroup
                  style={{ paddingLeft: '10px' }}
                  value={selectedLanguage}
                  color="primary"
                  exclusive
                  onChange={handlechangelanguage}
                >
                  {['th', 'en'].map((language) => (
                    <ToggleButton
                      key={language}
                      value={language}
                      size='small'
                      style={{
                        backgroundColor: selectedLanguage === language ? '#1976d2' : 'white',
                        color: selectedLanguage === language ? 'white' : 'black',
                        padding: '3px',
                        border: '1px solid white',
                      }}
                    >
                      {language.toUpperCase()}
                    </ToggleButton>
                  ))}
                </ToggleButtonGroup>
              </span>
            </p>
          </div>
        </div>
        <div className="nav-div-r1">
          <div className="UserDetail ">
            <div style={{ cursor: 'pointer' }} onClick={openUserDetail}>
              {/* <img src={iconUser} className="nav-icon" alt="iconUser" /> */}
            </div>
            <div className="UserDetailPopup">
              <ModalComponent
                className="UserDetailPopup"
                id="UserDetail"
                isOpen={OpenUserDetail}
                onClose={closeUserDetail}
                size={"sm"}
                title='info'
                showHaedCloseButton={true}
              >
                <UserDetail
                  setFormData={userData}
                  closeModalMap={closeUserDetail}
                />
              </ModalComponent>
            </div>
          </div>
          <button className="hove-icon">
            <PersonCircle
              style={{
                fontSize: '30px',
              }}
              onClick={openUserDetail}
            />
          </button>
          <div style={{ position: "relative" }}>
            <div>
              Role {!userData?.groupNo ? null : userData?.groupNo + " - " + userData?.chiefNo}

            </div>
            <div>
              <Dropdown
                style={{ fontSize: "14px" }} className="Dropdownsub"
                // placeholder={userData?.subList?.[0]?.subNo + " - " + userData?.subList?.[0]?.subName}
                options={options}
                 value={selectedValue}
                 onChange={handlechangevalue}
                />
            </div>
          </div>
          <div>
            <img src={iconLogout} className="nav-icon1" style={{ cursor: "pointer" }} alt="iconLogout" onClick={handleClickLogout} />
          </div>
        </div>
      </div>
    </div>
  );
}